import React, { RefObject, useState, useEffect, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { AppState } from "store/store"
import { useSelector, useDispatch } from "react-redux"
import { planActions } from "store/actions/PlanAction"
import { qrActions } from "store/actions/QRAction"
import { userInfoActions } from "store/actions/UserInfoAction"
import store from "configureStore"
import { persistStore } from "redux-persist"
import Toast from "components/common/Toast"
import Layout from "components/Layout/Layout"
import CommonStepBar from "components/common/CommonStepBar"
import ButtonWithCamera from "components/Button/ButtonWithCamera"
import CommonTitle from "components/common/CommonTitle"
import Modal from "@mui/material/Modal"
import { stopStreamedVideo } from "utils/StreamedVideo"
import { isTypeAQR2, isTypeAQR3, isTypeAQR5, isTypeKQR4, isTypeKQR5, QrCheck } from "utils/QrChecks"
import { Box, Container } from "@mui/material"
import { BrowserQRCodeReader } from "@zxing/browser"
import {
  QRCodeMultiReader,
  MultipleBarcodeReader,
  BinaryBitmap,
  Result,
  DecodeHintType,
  BarcodeFormat
} from "@zxing/library"
import GoBackButton from "components/Button/GoBackButton"
import { buildUrlWithParams } from "utils/BuildUrlWithParams"
import { APP_URL, Colors } from "../../Const"
import styles from "./QRReader.module.scss"
import stylesUsage from "./Usage.module.scss"

/**
 * Step1 車検証読取画面（スキャン）
 * スキャンされた車検証をZxingで読み取る
 * 読み取りが成功した場合、Step2車情報入力画面に遷移
 */
const Usage = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [openScan, setOpenScan] = useState(false)
  const videoRef: RefObject<HTMLVideoElement> = useRef(null)
  const vCanvasRef: RefObject<HTMLCanvasElement> = useRef(null)
  const sub1CanvasRef: RefObject<HTMLCanvasElement> = useRef(null)
  const sub2CanvasRef: RefObject<HTMLCanvasElement> = useRef(null)
  const sub4CanvasRef: RefObject<HTMLCanvasElement> = useRef(null)
  const sub5CanvasRef: RefObject<HTMLCanvasElement> = useRef(null)
  const [typeAResult2, setTypeAResult2] = useState("")
  const [typeAResult3, setTypeAResult3] = useState("")
  const [typeAResult5, setTypeAResult5] = useState("")
  const [typeKResult4, setTypeKResult4] = useState("")
  const [typeKResult5, setTypeKResult5] = useState("")
  const [openA2, setOpenA2] = useState(false)
  const [openA3, setOpenA3] = useState(false)
  const [openA5, setOpenA5] = useState(false)
  const [openK4, setOpenK4] = useState(false)
  const [openK5, setOpenK5] = useState(false)
  const [timerId, setTimerId] = useState(0)
  const [animationId, setAnimationId] = useState<number>(0)
  const [isCameraReady, setIsCameraReady] = useState(false)
  const couponCode = useSelector((state: AppState) => state.couponCode.couponCode)
  const cameraOff = useSelector((state: AppState) => state.cameraOff.cameraOff)

  const setCanvasSize = (canvas: any, video: any) => {
    let videoDrawHeight = video.clientHeight
    let videoDrawWidth = video.clientWidth
    let offsetVideoDy = 0
    videoDrawHeight = video.clientWidth * (window.innerHeight / window.innerWidth)
    videoDrawWidth = video.clientWidth
    offsetVideoDy = (videoDrawHeight - video.clientHeight) / 2
    canvas.current.width = videoDrawWidth
    canvas.current.height = videoDrawHeight
  }

  const setZxing = (subCanvas: any, x: number, y: number, w: number, h: number): any => {
    if (vCanvasRef != null && vCanvasRef.current != null) {
      const vContext = vCanvasRef.current.getContext("2d")
      if (vContext != null && subCanvas.current != null) {
        const imageData = vContext.getImageData(x, y, w, h)
        subCanvas.current.width = w
        subCanvas.current.height = h
        const ctx = subCanvas.current.getContext("2d")
        ctx.putImageData(imageData, 0, 0)
        try {
          const bitmap: BinaryBitmap = BrowserQRCodeReader.createBinaryBitmapFromCanvas(subCanvas.current)
          const qrCodeMultiReader: MultipleBarcodeReader = new QRCodeMultiReader()
          // 精度、速度向上のためのhintsを追加
          const hints = new Map()
          const formats = [BarcodeFormat.QR_CODE]
          hints.set(DecodeHintType.POSSIBLE_FORMATS, formats)
          hints.set(DecodeHintType.TRY_HARDER, true)
          // QRコード画像を一括でdecode
          const results: Result[] = qrCodeMultiReader.decodeMultiple(bitmap, hints)
          // Landscapeでなければ読み取り処理を実施しない
          if (window.matchMedia("(orientation: landscape)").matches && results && results.length) {
            results.forEach((r) => {
              console.info(r)
              if (isTypeAQR2(r.getText())) {
                console.info(`atype qr2 === ${r.getText()}`)
                setTypeAResult2(r.getText())
              }
              if (isTypeAQR3(r.getText())) {
                console.info(`atype qr3 === ${r.getText()}`)
                setTypeAResult3(r.getText())
              }
              if (isTypeAQR5(r.getText())) {
                console.info(`atype qr5 === ${r.getText()}`)
                setTypeAResult5(r.getText())
              }
              if (isTypeKQR4(r.getText())) {
                console.info(`ktype qr4 === ${r.getText()}`)
                setTypeKResult4(r.getText())
              }
              if (isTypeKQR5(r.getText())) {
                console.info(`ktype qr5 === ${r.getText()}`)
                setTypeKResult5(r.getText())
              }
            })
          }
        } catch (err) {
          return false
        }
      }
    }
    return false
  }

  const setCoodinate = (canvas: any) => {
    const baseW = Math.round(canvas.current.width * 0.875)
    const baseH = Math.round(canvas.current.height * 0.35)
    const marginX = (canvas.current.width - baseW) / 2
    const marginY = Math.round((canvas.current.height - baseH) / 2)
    const baseGap = Math.round(baseW * (3 / 14))
    return { baseW, baseH, marginX, marginY, baseGap }
  }

  const drawBoundingBox = (ctx: any, w: number, h: number, x: number, y: number, canvas: any) => {
    // 読取領域の四角に線を描く
    const base = Math.round(canvas.current.width * 0.005)
    const marginVertical = 10
    const marginHorizontal = 5
    const lengthVertical = base * 10
    const lengthHorizontal = base * 10

    // 新しいパスを作成する
    ctx.beginPath()
    // 線の色
    ctx.strokeStyle = "#FF8200"
    // 線の太さ
    ctx.lineWidth = base
    // 左上
    ctx.moveTo(x + marginHorizontal, y + marginVertical + lengthVertical)
    ctx.lineTo(x + marginHorizontal, y + marginVertical)
    ctx.lineTo(x + marginHorizontal + lengthHorizontal, y + marginVertical)

    // 右上
    ctx.moveTo(x + w - marginHorizontal, y + marginVertical + lengthVertical)
    ctx.lineTo(x + w - marginHorizontal, y + marginVertical)
    ctx.lineTo(x + w - marginHorizontal - lengthHorizontal, y + marginVertical)

    // 右下
    ctx.moveTo(x + w - marginHorizontal, y + h - marginVertical - lengthVertical)
    ctx.lineTo(x + w - marginHorizontal, y + h - marginVertical)
    ctx.lineTo(x + w - marginHorizontal - lengthHorizontal, y + h - marginVertical)

    // 左下
    ctx.moveTo(x + marginHorizontal, y + h - marginVertical - lengthVertical)
    ctx.lineTo(x + marginHorizontal, y + h - marginVertical)
    ctx.lineTo(x + marginHorizontal + lengthHorizontal, y + h - marginVertical)

    // 輪郭をなぞる方式で図形を描く
    ctx.stroke()
  }

  const areaJudgment = (ctx: any, baseW: number, baseH: number, marginX: number, marginY: number, baseGap: number) => {
    const JudgBaseW = baseW + baseGap
    const JudgBaseH = baseH * 2
    const JudgMarginX = marginX - baseGap / 2
    const JudgMarginY = marginY - baseH / 2
    ctx.beginPath()
    // 線の色 範囲確認のためにAlpha=0で透明にしておく
    ctx.strokeStyle = "rgba(255, 255, 0, 0)"
    // 線の太さ
    ctx.lineWidth = 1
    ctx.strokeRect(JudgMarginX, JudgMarginY, JudgBaseW, JudgBaseH)
    ctx.closePath()
    if (baseW > 0 && marginY > 0) {
      setZxing(sub1CanvasRef, JudgMarginX, JudgMarginY, JudgBaseW, JudgBaseH)
    }
  }

  const draw = () => {
    if (vCanvasRef != null && vCanvasRef.current != null) {
      const vContext = vCanvasRef.current.getContext("2d")
      if (vContext != null && videoRef != null && videoRef.current != null) {
        const vVideoRef = videoRef.current

        // 画面描画用の高さ、幅を設定する
        setCanvasSize(vCanvasRef, vVideoRef)
        // 設定されたサイズでcanvasへ描画する
        vContext.drawImage(videoRef.current, 0, 0)

        // 境界線BOXの座標を取得
        const { baseW, baseH, marginX, marginY, baseGap } = setCoodinate(vCanvasRef)

        // 境界線BOXとOK/NoUseを描画
        drawBoundingBox(vContext, baseW, baseH, marginX, marginY, vCanvasRef)
        // 実際に判定する座標の取得と判定
        areaJudgment(vContext, baseW, baseH, marginX, marginY, baseGap)
      }
    }
    // animationIdを保存
    const id = requestAnimationFrame(draw)
    setAnimationId(id)
  }

  // isCameraReadyがtrueになったらdrawループを開始
  useEffect(() => {
    if (isCameraReady && openScan) {
      requestAnimationFrame(draw)
    }
  }, [isCameraReady, openScan])

  // videoデバイスの設定/接続/切断
  const constraints = {
    audio: false,
    video: {
      width: { min: 640, max: 1920 },
      height: { min: 360, max: 1080 },
      facingMode: "environment"
    }
  }
  const startCamera = async () => {
    // まずモーダルを開く
    setOpenScan(true)
    await new Promise((resolve) => setTimeout(resolve, 100))

    await window.navigator.mediaDevices
      .getUserMedia(constraints)
      .then(async (stream) => {
        // 成功した時の処理
        if (videoRef != null && videoRef.current != null) {
          videoRef.current.srcObject = stream
          
          // メタデータ読み込み待機
          await new Promise<void>((resolve) => {
            if (videoRef.current) {
              videoRef.current.onloadedmetadata = () => resolve()
            }
          })
          
          // 明示的にplay()を呼び出し
          await videoRef.current.play()
          
          // レイアウト完了待機
          await new Promise((resolve) => setTimeout(resolve, 500))
          
          // カメラ完全に起動されてからスキャン用のビューを表示する
          setIsCameraReady(true)
        }
      })
      .catch((err) => {
        // エラー時
        console.error("getUserMedia Err:", err)
        setOpenScan(false)
      })
    // カメラ接続を切断するためのリロード
    window.addEventListener("popstate", (e) => {
      window.location.reload()
    })
  }

  const stopCamera = async () => {
    if (animationId) {
      cancelAnimationFrame(animationId)
      setAnimationId(0)
    }
    if (videoRef != null && videoRef.current != null) {
      stopStreamedVideo(videoRef.current)
    }
    setIsCameraReady(false)
  }

  // カメラ停止処理（読み取り画面のまま保持した場合のみ）
  useEffect(() => {
    if (openScan) {
      const id = window.setTimeout(
        () => {
          navigate(buildUrlWithParams(APP_URL.TOP, couponCode, cameraOff))
          // カメラ接続を切断するためのリロード
          window.location.reload()
          // 1000ms * 60s * 10m
        },
        1000 * 60 * 10
      )
      setTimerId(id)
    }
  }, [openScan])

  useEffect(() => {
    const isNeccesaryToReset = !(openA2 && openA3 && openA5) || !(openK4 && openK5)
    if (timerId && isNeccesaryToReset) {
      window.clearTimeout(timerId) // 読み取りに問題がなければ、カメラ停止処理をクリア}
    }
  }, [openA2, openA3, openA5, openK4, openK5])

  const setFormatExtraction = () => {
    const { vehicleType, carModel, firstInspectionYear, firstInspectionMonth } = QrCheck(
      typeAResult2,
      typeAResult3,
      typeAResult5,
      typeKResult4,
      typeKResult5
    )

    // 用途車種が取得できない場合は見積もり対象外エラー
    if (!vehicleType) {
      setTimeout(() => {
        stopCamera()
        navigate(APP_URL.ERROR, {
          state: { isNotCovered: true }
        })
      }, 1000)
      return
    }
    dispatch(qrActions.updateVehicleType(vehicleType)) // 用途車種
    dispatch(qrActions.updateCarModel(carModel)) // 型式
    dispatch(qrActions.updateFirstInspectionYear(firstInspectionYear)) // 初度登録年
    dispatch(qrActions.updateFirstInspectionMonth(firstInspectionMonth)) // 初度登録月
    dispatch(qrActions.updateIsScan(true)) // スキャンフラグ

    setTimeout(() => {
      stopCamera()
      navigate(APP_URL.RESULT)
    }, 1000)
  }

  useEffect(() => {
    if (typeAResult2) setOpenA2(true)
    if (typeAResult3) setOpenA3(true)
    if (typeAResult5) setOpenA5(true)
    if (typeKResult4) setOpenK4(true)
    if (typeKResult5) setOpenK5(true)

    // 読み取ったデータから必要な値を抽出する
    if ((typeAResult2 && typeAResult3 && typeAResult5) || (typeKResult4 && typeKResult5)) {
      setFormatExtraction()
    }
  }, [typeAResult2, typeAResult3, typeAResult5, typeKResult4, typeKResult5])

  useEffect(() => {
    dispatch(planActions.reset())
    dispatch(qrActions.reset())
    dispatch(userInfoActions.reset())
  }, [])

  const statusBar = () => {
    let process = 0
    if (openA2) process += 33
    if (openA3) process += 33
    if (openA5) process += 34
    if (openK4) process += 50
    if (openK5) process += 50
    let message = ""
    if (process === 100) {
      // 100%
      message = "読み取りが完了しました。"
    }
    if (process < 100) {
      message = "二次元バーコードをガイドに合わせてカメラをかざしてください。"
    }
    return (
      <div className={styles.processBar}>
        <div style={{ width: `${process}%` }} className={Number(process) > 99 ? styles.process100 : ""}>
          &nbsp;
        </div>
        <span>{message}</span>
      </div>
    )
  }

  return (
    <Layout>
      <div className={stylesUsage.root}>
        <CommonStepBar num={1} />
        <CommonTitle titles={["車検証を読み取る"]} read="" />
        <Box className={stylesUsage.howtoImage}>
          <img src="./howto.jpg" alt="車検証を読み取る" />
          <p>
            スマートフォンを横向きにし、車検証の二次元バーコードが全て収まるようにカメラをかざしてください。
            <span>画面の縦向きロックを解除してください。</span>
            <span>車検証は可能な限り原本をご用意ください。</span>
            <span>
              軽自動車は読み取りに時間がかかる場合がございます。読み取れない場合、直接入力にてご試算をお願いします。
            </span>
          </p>
        </Box>
        <Box className={stylesUsage.cameraButton}>
          <ButtonWithCamera
            color={Colors.Orange}
            text="読み取り開始"
            onClick={() => {
              startCamera()
            }}
          />
        </Box>
        <GoBackButton top />
      </div>
      <Modal className={stylesUsage.modal} open={openScan}>
        <Container maxWidth="md" className={styles.root}>
          <Container maxWidth="md" className={styles.contents}>
            <div className={styles.videobox}>
              <video id="video" autoPlay muted playsInline ref={videoRef} />
            </div>
            <div className={styles.canvasbox}>
              <canvas ref={vCanvasRef} className={styles.vCanvas} />
            </div>
            <div className={styles.canvasHidden}>
              <canvas ref={sub1CanvasRef} className={styles.canvasHidden} />
              <canvas ref={sub2CanvasRef} className={styles.canvasHidden} />
              <canvas ref={sub4CanvasRef} className={styles.canvasHidden} />
              <canvas ref={sub5CanvasRef} className={styles.canvasHidden} />
            </div>
            {process.env.NODE_ENV === "development" && (
              <div className={styles.result}>
                <Toast open={openA2} onClick={() => setOpenA2(false)} result={typeAResult2} />
                <Toast open={openA3} onClick={() => setOpenA3(false)} result={typeAResult3} />
                <Toast open={openA5} onClick={() => setOpenA5(false)} result={typeAResult5} />
                <Toast open={openK4} onClick={() => setOpenK4(false)} result={typeKResult4} />
                <Toast open={openK5} onClick={() => setOpenK5(false)} result={typeKResult5} />
              </div>
            )}
            <div className={styles.header}>{statusBar()}</div>
            <div className={styles.footer}>
              <div
                className={styles.goBack}
                aria-hidden
                onClick={() => {
                  window.location.reload()
                }}
              >
                <span>前の画面に戻る</span>
              </div>
              <div
                className={styles.goResult}
                aria-hidden
                onClick={() => {
                  stopCamera()
                  // ストアの初期化
                  dispatch(planActions.reset())
                  dispatch(qrActions.reset())
                  dispatch(userInfoActions.reset())
                  navigate(APP_URL.RESULT)
                }}
              >
                <span>読み取れない場合はこちら（直接入力）</span>
              </div>
            </div>
            <div className={styles.portrait}>
              <p>
                スマートフォンを横向きにしてください。
                <span>画面を縦向きにロックしている場合、ロックを解除してください。</span>
              </p>
            </div>
          </Container>
        </Container>
      </Modal>
    </Layout>
  )
}

export default Usage
